/* ============================================================
   Nalanda Enterprises theme, Direction B "Counter"
   Vanilla JS. No framework, no build step.
   Every rule here either created polish or prevented a shipped bug.
   ============================================================ */
(function () {
  'use strict';

  var reduce = matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- hero line reveal ---------- */
  requestAnimationFrame(function () {
    document.body.classList.add('is-loaded');
  });

  /* ---------- sticky header shadow ---------- */
  var hdr = document.querySelector('[data-header]');
  if (hdr) {
    var onScrollHdr = function () { hdr.classList.toggle('is-stuck', window.scrollY > 8); };
    addEventListener('scroll', onScrollHdr, { passive: true });
    onScrollHdr();
  }

  /* ---------- entrance choreography ----------
     The retirement class is "is-settled", deliberately NOT "done":
     a bare .done selector is taken by form success states, and using it
     here hid every section about a second after it appeared. */
  var seen = new WeakSet();
  var io = null;

  function armReveals() {
    if (io) return;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting || seen.has(e.target)) return;
        seen.add(e.target);
        e.target.classList.add('is-in');
        var n = e.target.children.length;
        setTimeout(function () { e.target.classList.add('is-settled'); }, 740 + n * 60);
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    document.querySelectorAll('.reveal').forEach(function (el) {
      if (!seen.has(el)) io.observe(el);
    });
  }

  function pinReveals() {
    if (io) { io.disconnect(); io = null; }
    document.querySelectorAll('.reveal').forEach(function (el) {
      el.classList.add('is-in', 'is-settled');
    });
  }

  if (reduce.matches) pinReveals(); else armReveals();

  /* ---------- marquee loops get a duplicate so the join is invisible ---------- */
  document.querySelectorAll('[data-marquee]').forEach(function (el) {
    el.innerHTML += el.innerHTML;
  });

  /* ---------- the budget dial, the site's one interactive moment ----------
     Enacts the store's own idea: most people shop the number, not the brand. */
  var dial = document.querySelector('[data-budget]');
  if (dial) {
    var rng = dial.querySelector('input[type=range]');
    var out = dial.querySelector('[data-budget-value]');
    var picks = [].slice.call(dial.querySelectorAll('[data-max]'));
    var lastTxt = '';

    var fmt = function (n) {
      return '₹' + Number(n).toLocaleString('en-IN');
    };

    var paint = function () {
      var v = +rng.value;
      var txt = fmt(v);
      /* write to the DOM only on change; per-frame writes are what make it choppy */
      if (txt !== lastTxt) {
        lastTxt = txt;
        out.textContent = txt;
        rng.setAttribute('aria-valuetext', v + ' rupees');
      }
      rng.style.setProperty('--fill', ((v - rng.min) / (rng.max - rng.min) * 100).toFixed(1) + '%');
      picks.forEach(function (p) { p.classList.toggle('is-out', +p.dataset.max > v); });
    };

    rng.addEventListener('input', paint);
    paint();
  }

  /* ---------- quantity steppers ---------- */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qty-step]');
      if (!b) return;
      var next = Math.max(1, (parseInt(input.value, 10) || 1) + (+b.dataset.qtyStep));
      if (String(next) !== input.value) {
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });


  /* ---------- image loading ----------
     Tiles reserve their space in CSS, so nothing shifts. This just flips a flag
     when a picture has actually decoded, which hides the shimmer and fades the
     image in. Images already in cache fire no load event, hence the complete check. */
  function markLoaded(img){
    if (img.dataset.loaded) return;
    img.dataset.loaded = '1';
  }
  function watchImages(root){
    (root || document).querySelectorAll('img.pcard__img, img.pdp__img').forEach(function(img){
      if (img.complete && img.naturalWidth > 0) markLoaded(img);
      else {
        img.addEventListener('load', function(){ markLoaded(img); }, {once:true});
        img.addEventListener('error', function(){ markLoaded(img); }, {once:true});
      }
    });
  }
  watchImages();
  /* sections rendered later (filtered collections) need the same treatment */
  new MutationObserver(function(muts){
    muts.forEach(function(m){
      m.addedNodes.forEach(function(n){ if (n.nodeType === 1) watchImages(n); });
    });
  }).observe(document.body, {childList:true, subtree:true});

  /* ---------- pause every animation on a hidden tab ----------
     animation-play-state does not inherit, so the CSS rule has to reach
     descendants and pseudo-elements itself. This class turns it on. */
  document.addEventListener('visibilitychange', function () {
    document.body.classList.toggle('is-paused', document.hidden);
  });

  /* ---------- reduced motion, honoured live and in BOTH directions ----------
     Re-arming the reveals while leaving everything else pinned is the
     half-fix that looks done and is not. */
  reduce.addEventListener('change', function (e) {
    if (e.matches) pinReveals(); else armReveals();
  });
})();
